import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import "../../styles/components/why-think-plus.scss";

const WhyThinkPlus = () => {
	let images = useStaticQuery(graphql`
		{
			EvolutionGold19: file(
				relativePath: { eq: "awards/EvolutionGold19.png" }
			) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			EvolutionSilver19: file(
				relativePath: { eq: "awards/EvolutionSilver19.png" }
			) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			EvolutionBronze19: file(
				relativePath: { eq: "awards/EvolutionBronze19.png" }
			) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			FranchiseAwards18: file(
				relativePath: { eq: "awards/FranchiseAwards18.png" }
			) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			MobileAwards18: file(relativePath: { eq: "awards/MobileAwards18.png" }) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			SWA_2016_Gold: file(relativePath: { eq: "awards/SWA_2016_Gold.png" }) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			SWA_2016_Silver: file(
				relativePath: { eq: "awards/SWA_2016_Silver.png" }
			) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			SWA_2015_Gold: file(relativePath: { eq: "awards/SWA_2015_Gold.png" }) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			SPI_GroupAward: file(relativePath: { eq: "awards/SPI_GroupAward.png" }) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			SWA_2013_Bronze: file(
				relativePath: { eq: "awards/SWA_2013_Bronze.png" }
			) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			Efarmogiada_Award: file(
				relativePath: { eq: "awards/Efarmogiada_Award.png" }
			) {
				childImageSharp {
					gatsbyImageData(width: 150, layout: CONSTRAINED)
				}
			}
			Evolution_Awards_2026: file(
				relativePath: { eq: "awards/think-plus-evolution-awards-1.webp" }
			) {
				childImageSharp {
					gatsbyImageData(width: 664, layout: CONSTRAINED)
				}
			}
		}
	`);
	return (
		<section className="why-think-plus text-align-center">
			<div className="container medium">
				<h2 className="dec-header--underline">ΓΙΑΤΙ ΤΗΝ THINK PLUS</h2>
				<p className="h5 why-think-plus__text">
					Γιατί είμαστε Platinum E-commerce Agency of the Year,
					<br />η κορυφαία διάκριση στο ελληνικό ψηφιακό περιβάλλον.
				</p>
				<p>
					Γιατί σχεδιάζουμε και δημιουργούμε με στρατηγική πρόθεση, από digital
					campaigns και video production έως Shopify ecommerce infrastructure
					και media strategy. Γιατί διαθέτουμε αποδεδειγμένη εμπειρία σε complex
					projects, enterprise-grade υλοποιήσεις και integrated digital
					solutions. Γιατί μετράμε επιτυχία σε αποτελέσματα, όχι σε παραδόσεις.
					Και πάνω απ' όλα, γιατί παραμένουμε δίπλα σας μακροπρόθεσμα ως
					στρατηγικός συνεργάτης.
				</p>

				<p className="h5 why-think-plus__text">
					Πίσω από κάθε project κρύβεται μια ομάδα που το πιστεύει.
					<br />
					Στα e-volution Awards 2026, αυτή η δουλειά αναγνωρίστηκε με τη
					μεγαλύτερη διάκριση του κλάδου.
				</p>
				<div className="evolution-awards-img">
					<GatsbyImage
						image={images.Evolution_Awards_2026.childImageSharp.gatsbyImageData}
						alt="E-volution Gold Award"
					/>
				</div>
				<div className="why-think-plus__awards">
					<div>
						<GatsbyImage
							image={images.EvolutionGold19.childImageSharp.gatsbyImageData}
							alt="E-volution Gold Award"
						/>
						<strong>Χρυσό Βραβείο</strong>
						<p>
							στα E-volution Awards για το e-socks.gr ("Πελατοκεντρικότητα &amp;
							Διαδικασίες" - "Προσωποποιημένες Υπηρεσίες")
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.EvolutionSilver19.childImageSharp.gatsbyImageData}
							alt="E-volution Silver Award"
						/>
						<strong>Silver Βραβείο</strong>
						<p>
							στα E-volution Awards για το Skroutz Application ("Υπηρεσίες &amp;
							Υποδομές Ηλεκτρονικού Επιχειρείν" - "Υπηρεσίες Υποδομών")
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.EvolutionBronze19.childImageSharp.gatsbyImageData}
							alt="E-volution Bronze Award"
						/>
						<strong>Bronze Βραβείο</strong>
						<p>
							στα E-volution Awards για την MEL ("Ψηφιακή Επικοινωνία &amp;
							Marketing" - "Best Cross Border Marketing")
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.FranchiseAwards18.childImageSharp.gatsbyImageData}
							alt="Franchise Gold Award"
						/>
						<strong>Χρυσό Βραβείο</strong>
						<p>
							στα Franchise Awards 2018 (Best use of Technology - "Smileworks")
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.FranchiseAwards18.childImageSharp.gatsbyImageData}
							alt="Franchise Gold Award"
						/>
						<strong>Χρυσό Βραβείο</strong>
						<p>
							στα Franchise Awards 2018 (Most Innovative Concept - “Smileworks")
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.MobileAwards18.childImageSharp.gatsbyImageData}
							alt="E-volution Bronze Award"
						/>
						<strong>Δεύτερο Βραβείο</strong>
						<p>
							στα Mobile Excellence Awards 2018 στις καλύτερες Mobile Εφαρμογές
							- «Fitgate»
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.SWA_2016_Gold.childImageSharp.gatsbyImageData}
							alt="Gold Social Media Award"
						/>
						<strong>Χρυσό Βραβείο</strong>
						<p>
							στα Social Media Awards 2016 (Best use of social media in Real
							Life)
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.SWA_2016_Silver.childImageSharp.gatsbyImageData}
							alt="Silver Social Media Award"
						/>
						<strong>Silver Βραβείο</strong>
						<p>στα Social Media Awards 2016 «Innovation in Social Media»</p>
					</div>
					<div>
						<GatsbyImage
							image={images.SWA_2015_Gold.childImageSharp.gatsbyImageData}
							alt="Gold Social Media Award"
						/>
						<strong>Χρυσό Βραβείο</strong>
						<p>
							στα Social Media Awards 2015 (Best use of social media in Real
							Life)
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.SPI_GroupAward.childImageSharp.gatsbyImageData}
							alt="1st SPI Group Award"
						/>
						<strong>Πρώτο Διεθνές βραβείο</strong>
						<p>
							καλύτερης Facebook Ενέργειας για τις χρονιές 2012, 2013 &amp; 2014
							(SPI Group)
						</p>
					</div>
					<div>
						<GatsbyImage
							image={images.SWA_2013_Bronze.childImageSharp.gatsbyImageData}
							alt="Bronze Social Media Award"
						/>
						<strong>Δύο Βραβεία</strong>
						<p>στα Social Media Awards 2013 (Jägermeister &amp; Stolichnaya)</p>
					</div>
					<div>
						<GatsbyImage
							image={images.Efarmogiada_Award.childImageSharp.gatsbyImageData}
							alt="1st SPI Group Award"
						/>
						<strong>Δεύτερο βραβείο</strong>
						<p>
							στην ελληνική «Εφαρμογιάδα» για την mobile εφαρμογή «FaceMetrics»
							υπό την αιγίδα της Εθνικής Τράπεζας
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default WhyThinkPlus;
